// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"635c1eca","453":"0fe20891","777":"65bfd100"}[chunkId] + ".chunk.js";
};